import CouponList from "./CouponList";

export default CouponList;